export const CONFLUENCE_ORIGIN = "https://sio-com.atlassian.net";
